<form
    nz-form
    [nzLayout]="'inline'"
>
    <!-- Name -->
    <nz-form-item>
        <nz-form-label nzRequired>Name</nz-form-label>
        <nz-form-control
            [nzValidateStatus]="errors.name"
            nzErrorTip="Required"
        >
            <nz-input-group>
                <input
                    name="label"
                    required
                    [disabled]="!edit"
                    [(ngModel)]="_recurringTask.label"
                    nz-input
                    placeholder="Recurring task name"
                />
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>

    <!-- spacer -->
    <div style="flex: 1"></div>

    <!-- Start -->
    <nz-form-item>
        <nz-form-label nzRequired>Start After</nz-form-label>
        <nz-form-control
            [nzValidateStatus]="errors.startDate"
            nzErrorTip="Required"
        >
            <nz-input-group>
                <nz-date-picker
                    name="startDate"
                    required
                    [disabled]="!edit"
                    [(ngModel)]="_recurringTask.startDate"
                ></nz-date-picker>
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>

    <!-- End -->
    <nz-form-item>
        <nz-form-label nzRequired>End On</nz-form-label>
        <nz-form-control
            [nzValidateStatus]="errors.endDate"
            nzErrorTip="Required"
        >
            <nz-input-group>
                <nz-date-picker
                    name="endDate"
                    required
                    [disabled]="!edit"
                    [(ngModel)]="_recurringTask.endDate"
                ></nz-date-picker>
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>
</form>
<br>

<h3>Recurring Task</h3>
<h4>All times are in the account's default timezone</h4>
<table style="width: 100%; margin-top: 30px">
    <tr style="height: 40px">
        <th class="day-header">Day</th>
        <th class="slots-header">Slots</th>
    </tr>

    <tr *ngFor="let day of weekMap | keyvalue">
        <td class="day-cell">
            <div style="padding-top: 10px; padding-bottom: 10px">
                {{ day.value.name }}
            </div>
        </td>
        <td class="slot-cell">
            <div style="display: flex; flex-wrap: wrap; align-items: center">
                <!-- ----------------------------------------------------------------------- -->
                <!--                                  slots                                  -->
                <!-- ----------------------------------------------------------------------- -->

                <recurring-task-slot
                    *ngFor="let slot of day.value.slots; index as i"
                    [edit]="edit"
                    [start]="slot.sDate"
                    [error]="slot.error"
                    (deleteClicked)="removeSlot(day.key, i)"
                    (timeChanged)="updateSlot(day.key, i, $event)"
                ></recurring-task-slot>

                <!-- ----------------------------------------------------------------------- -->
                <!--                                add slot                                 -->
                <!-- ----------------------------------------------------------------------- -->
                <div
                    class="add-slot"
                    *ngIf="edit"
                    (click)="addSlot(day.key)"
                >
                    <i class="fa-solid fa-plus"></i>
                </div>
            </div>
        </td>
    </tr>
</table>



<!-- ----------------------------------------------------------------------- -->
<!--                              Extras Editor                              -->
<!-- ----------------------------------------------------------------------- -->
<h2 style="margin-top: 2rem;">Template</h2>

<json-editor
    #jsonEditor
    [formControl]="jsonCtrl"
></json-editor>